import { useEffect, useRef, useState, createRef, useCallback, useContext } from "react";
import CloseLock from "../../assets/svg-icons/closeLock";
import OpenLock from "../../assets/svg-icons/openLock";
import SwapIcon from "../../assets/svg-icons/swap";
import Header from "../../components/Header";
import GetFont from "../../assets/svg-icons/GetFont";
import CloseIcon from "../../assets/svg-icons/closeIcon";
import { useRandomFont } from "../../hooks/useRandomFont";
import { useKeyDown } from "../../hooks/useKeyDown";
import ChangeFont from "../../assets/svg-icons/changeFont";

import { useDispatch, useSelector } from "react-redux";
import { CHANGE_FONT, DISABLE_KEY_DOWN, FONT_DESCRIPTION_LOCK, FONT_HEADING_LOCK, IS_FONT_LOADING } from "../../store/types/font";
import PairSection from "../../components/PairSection";
import RCSlider from "../../components/RCSlider";
import TextareaAutosize from 'react-textarea-autosize';
import { TOOLTIP, reDirection_url_map, CAMPAIGN_METADATA, HEADER_INPUT, DESCRIPTION_INPUT, FONT_PAIR_HEADER, FONT_PAIR_BODY} from "../../constant";

import {
  ReactiveBase,
  ReactiveList,
  DataSearch
} from "@appbaseio/reactivesearch";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  EmailIcon
} from "react-share";
import { REACT_APP_ELASTIC_CREDENTIALS, REACT_APP_ELASTIC_URL } from "../../constant/environment";
import { useFonts } from "../../hooks/useFonts";
import { getUser } from "../../utils/Fonts";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import FileCopy from "../../assets/svg-icons/FileCopy";
import { Link, useSearchParams } from "react-router-dom";

import useUndoableState from "../../hooks/useRedo";
import useOutsideClick from "../../hooks/useOutsideClick";

import {isMobile } from 'react-device-detect';
import ChangeFontSize from "../../assets/svg-icons/ChangeFontSize";
import Cross from "../../assets/svg-icons/Cross";
import ArrowBack from "../../assets/svg-icons/arrowBack";
import Tick from "../../assets/svg-icons/tick";
import { UserContext } from "../../App";
const FontFaceObserver = require('fontfaceobserver');
const Playground = (props) => {

    const {
      state: doc,
      setState: setDoc,
      resetState: resetDoc,
      index: docStateIndex,
      lastIndex: docStateLastIndex,
      goBack: undoDoc,
      goForward: redoDoc
    } = useUndoableState({});
    const canUndo = docStateIndex > 0;
    const canRedo = docStateIndex < docStateLastIndex;

  let [searchParams, setSearchParams] = useSearchParams();

  useRandomFont();

  useFonts();
  const playgroundRef = createRef(null)
  const changeFontSize = useRef();
  const dispatch = useDispatch();
  const [largeFontStore, setLargeFontStore] = useState()
  const [largeFontLocked, setLargeFontLocked] = useState(false)
  const [smallFontStore, setSmallFontStore] = useState()
  const [showPairSec, setShowPairSec] = useState(false)
  const [showTutorial, setShowTutorial] = useState(false);
  const [shareUrlLink,setShareUrlLink] = useState("")
  const [showSidebar, setShowSidebar] = useState(false);
  const [showSmallScrolledWeb, setShowSmallScrolledWeb] = useState(false)
  const [loader, setLoader] = useState(false)

  const [likedPair, setLikedPair] = useState([])
  const [isKeyboardOpen, setisKeyboardOpen] = useState('')
  const {headerInput, setheaderInput} = useContext(UserContext);
  const {descriptionInput, setdescriptionInput} = useContext(UserContext);
  const {smallFontSizeUpdated, setSmallFontSizeUpdated} = useContext(UserContext);
  const {largeFontSizeUpdated, setLargeFontSizeUpdated} = useContext(UserContext);
  const {headerInputUpdated, setheaderInputUpdated} = useContext(UserContext);
  const {descriptionInputUpdated, setdescriptionInputUpdated} = useContext(UserContext);
  const [showGetFontHeading, setShowGetFontHeading] = useState(false);
  const [showGetFontBody, setShowGetFontBody] = useState(false);

  // const PlaygroundLinkRender = () => {

  const [activeIndex, setActiveIndex] = useState(0)
  const [activeIndexSmall, setActiveIndexSmall] = useState(0)
  const [scrolledWeb, setScrolledWeb] = useState(false)
  const [smallFontSize, setSmallFontSize] = useState(22);
  const [largeFontSize, setLargeFontSize] = useState(48);
  const [showInstructions, setShowInstructions] = useState(true);

  const { fontHeadingLock, fontDescriptionLock, isFontLoading } = useSelector((state) => state.font);
  const { darkTheme } = useSelector((state) => state.theme);
  const mobileTextActions = useRef(null);
  // const [textActionsBottom, setTextActionsBottom] = useState('calc(100% - 80px)');
  const [showFontSlider, setShowFontSlider] = useState(false);

  const onScroll = useCallback((event) => {
    if(fontHeadingLock) return;
    if (headerInput === '') return;
    setScrolledWeb(true);
    // const [element] = document.getElementsByClassName("font-list-search")
    // const activeClassElement = document.querySelector('.active');
    // if (!activeClassElement) return
    // if (!activeClassElement.getBoundingClientRect()) return
    // const isUpOrDown = event.wheelDelta ? event.wheelDelta : -1 * event.deltaY;
    // isUpOrDown > 0 ? handleUpScroll(element, activeClassElement) : handleDownScroll(element, activeClassElement);
    // if(activeClassElement.childNodes.length !== 2) {
    //   const parentElement = document.getElementsByClassName("font-field-lists")[0];
    //   parentElement.firstChild.childNodes[1].className = "input-field-area active";
    // }
  }, [fontHeadingLock, headerInput]);


  const onSmallScroll = useCallback((event) => {
    if(fontDescriptionLock) return;
    if (descriptionInput === '') return;
    setShowSmallScrolledWeb(true);
    // const [_, element] = document.getElementsByClassName("font-list-search")
    // const activeClassElement = document.querySelector('.active');
    // if (!activeClassElement) return
    // if (!activeClassElement.getBoundingClientRect()) return
    // const isUpOrDown = event.wheelDelta ? event.wheelDelta : -1 * event.deltaY;
    // isUpOrDown > 0 ? handleUpScroll(element, activeClassElement) : handleDownScroll(element, activeClassElement);
    // if(activeClassElement.childNodes.length !== 2) {
    //   const parentElement = document.getElementsByClassName("font-field-lists")[1];
    //   parentElement.firstChild.childNodes[1].className = "input-field-area active";
    // }
  }, [descriptionInput, fontDescriptionLock]);

  const handleCloseTutorial = () => {localStorage.setItem("playground","yes");
  if(props.help) return setShowTutorial(true)
    setShowTutorial(false);
    }
  const ToggleTutorialUI = () => setShowTutorial(false);
  const { currentFontPair } = useSelector((state) => state.font);

  const onChangeDescriptionHandler = useCallback((e) => {
    setdescriptionInput(e.target.value);
    setdescriptionInputUpdated(true);
    dispatch({ type: DISABLE_KEY_DOWN, payload: false });
  }, [dispatch, setdescriptionInput, setdescriptionInputUpdated]);
  

  const closePairs = useCallback(() => {
    setShowPairSec(!showPairSec);
  }, [setShowPairSec, showPairSec]);

  useEffect(()=>{
    if(isKeyboardOpen === 'L'){
      // show and hide stuff
    }else if(isKeyboardOpen === 'S')
    {
      // show and hide stuff
    }
  },[isKeyboardOpen]);

  const handleChangeButton = useCallback(() => {
    if (isKeyboardOpen === 'L'){
        onScroll();
    }else if (isKeyboardOpen === 'S'){
        onSmallScroll();
      }
  }, [isKeyboardOpen, onScroll, onSmallScroll]);

  const handleChangeFontButton = useCallback(() => {
    setShowFontSlider(!showFontSlider);
  }, [setShowFontSlider, showFontSlider]);

  useOutsideClick(changeFontSize, () => {
    if(showFontSlider) {
      setShowFontSlider(false);
    }
  });

  const handleDoneEditing = () =>{
    setisKeyboardOpen('');
    setShowGetFontHeading(false);
    setShowGetFontBody(false);
  }
  useEffect(() => {
    getUser().then((response) => {
      setLikedPair(response.data.likedPairs)
      setLoader(false)
    })
  },[])

  useKeyDown({likedPair, setLikedPair, showPairSec, setLoader });

  useEffect(()=>  {
    const LocalStorageValue = localStorage.getItem('playground')
    if(LocalStorageValue === "yes" && !props.help){
      setShowTutorial(false)
    }
  },[props.help]);

  const getDefaultSmallValueForSlider = useCallback(() => {
    if(smallFontSizeUpdated) {
      return;
    }
    const winWidth = window.innerWidth;
    let fSize = 20;
    if ( winWidth >= 1920 ) {
      fSize = 32;
    } else if ( winWidth >= 1366 ) {
      fSize =  24;
    }
    setSmallFontSize(fSize);
  }, [smallFontSizeUpdated]);
  const getDefaultLargeValueForSlider = useCallback(() => {
    if(largeFontSizeUpdated) {
      return;
    }
    const winWidth = window.innerWidth;
    let fSize = 48;
    if ( winWidth >= 1920 ) {
      fSize = 104;
    } else if ( winWidth >= 1600) {
      fSize = 88;
    } else if ( winWidth >= 1366 ) {
      fSize = 80;
    } else if ( winWidth >= 990) {
      fSize = 64;
    }
    setLargeFontSize(fSize);
  }, [largeFontSizeUpdated]);

  const updateSmallTextOnResize = useCallback(() => {
    if(descriptionInputUpdated) {
      return;
    }
    if( window.innerWidth <= 768 ) {
      setdescriptionInput(FONT_PAIR_BODY);
    } else if(descriptionInput !== DESCRIPTION_INPUT) {
      setdescriptionInput(DESCRIPTION_INPUT);
    }
  }, [descriptionInput, descriptionInputUpdated, setdescriptionInput]);

  const updateLargeTextOnResize = useCallback(() => {
    if(headerInputUpdated) {
      return;
    }
    if( window.innerWidth <= 768 ) {
      setheaderInput(FONT_PAIR_HEADER);
    } else if(headerInput !== HEADER_INPUT) {
      setheaderInput(HEADER_INPUT);
    }
  }, [headerInput, headerInputUpdated, setheaderInput]);

  const handleLockLargeFont = useCallback(() => {
    let largefontObj = {
      'font-family': currentFontPair[0],
      'font-size' : `${largeFontSize}`,
    }
    setLargeFontStore(largefontObj)
    dispatch({ type: FONT_HEADING_LOCK, payload: !fontHeadingLock })
  }, [currentFontPair, dispatch, fontHeadingLock, largeFontSize]);

  const handleLockSmallFont = useCallback(() => {
    let smallfontObj = {
      'font-family': currentFontPair[0],
      'font-size' : `${smallFontSize}`
    }
    setSmallFontStore(smallfontObj)
    dispatch({ type: FONT_DESCRIPTION_LOCK, payload: !fontDescriptionLock })
  }, [currentFontPair, dispatch, fontDescriptionLock, smallFontSize]);

  const updateFooterInstructions = () => {
    setShowInstructions(false);
  };

  useEffect(() => {
    document?.querySelector('.active')?.children[1]?.focus();
 }, [activeIndex]);

 useEffect(() => {
  updateLargeTextOnResize();
  updateSmallTextOnResize();
  getDefaultSmallValueForSlider();
  getDefaultLargeValueForSlider();
 }, []);
 useEffect(() => {
  const handleResize = (e) => window.requestAnimationFrame(()=>{
    getDefaultSmallValueForSlider();
    getDefaultLargeValueForSlider();
    updateSmallTextOnResize();
    updateLargeTextOnResize();
  });
  window.addEventListener("resize", handleResize);
  if(showInstructions){
    document.addEventListener("click", updateFooterInstructions);
  }
  return () => {
    window.removeEventListener("resize", handleResize);
    document.removeEventListener("click", updateFooterInstructions);
  }
}, [getDefaultLargeValueForSlider, getDefaultSmallValueForSlider, headerInputUpdated, setLargeFontSizeUpdated, showInstructions, smallFontSizeUpdated, updateLargeTextOnResize, updateSmallTextOnResize]);

 const onChangeHeadingHandler = (e) => {
  setheaderInput(e.target.value);
  setheaderInputUpdated(true);
  dispatch({ type: DISABLE_KEY_DOWN, payload: false });
};

useEffect(() => {
  if(showSmallScrolledWeb || scrolledWeb)  dispatch({ type: DISABLE_KEY_DOWN, payload: true })
},[showSmallScrolledWeb, scrolledWeb, dispatch]);

useEffect(() => {
  if(isFontLoading) {
    const headingFont = new FontFaceObserver(currentFontPair[0]);
    const desFont = new FontFaceObserver(currentFontPair[1]);
    const timeout = 6000;
    
    Promise.all([headingFont.load(null, timeout), desFont.load(null, timeout)]).finally(() => {
      dispatch({ type: IS_FONT_LOADING, payload: false });
    });
  }
}, [currentFontPair, dispatch, isFontLoading]);
  const handleResetFont = (index,item) => { 
    setScrolledWeb(false);
    document.getElementById('largescroll').scrollTop = 0;
    if(!item && !index) {
      return
    }
    setActiveIndex(index);
    dispatch({ type: CHANGE_FONT, payload: [ item.font ,currentFontPair[1]] })
  }

  const handleResetFontSmall = (index,item) => { 
    setShowSmallScrolledWeb(false);
    document.getElementById('smallscroll').scrollTop = 0;
    if(!item && !index) {
      return
    }
    setActiveIndexSmall(index);
    dispatch({ type: CHANGE_FONT, payload: [ currentFontPair[0], item.font ] })
    document.getElementsByClassName("largeFont-list")[0].childNodes[0].children[1].className = "middleArrow-circled GA_changeHeadingFont"
  }

  const ReactiveHeaderList = ({data}) => {
    if(data.length <= 0) return
    return ( 
    data.map((item, index) => (
      <>
        { index === 0 &&
          <div className={`input-field-area`} key={-1}>
            <div className="font-name-search">
              <span className="font-name">{currentFontPair[0]}</span>
              <button className="btn select-font" onClick={() => handleResetFont()}>
                <Tick /> <span>Select</span> <span className="hide-on-mobile">the font</span>
              </button>
            </div>
            <TextareaAutosize
                value={HEADER_INPUT}
                style={{ fontFamily: `"${currentFontPair[0]?.toString()}"`, fontSize: `${largeFontSize}px`, lineHeight: `${1.2*largeFontSize}px`, pointerEvents: 'none' }}
                spellCheck="false"
              />
          </div>
        }
        <div className={`input-field-area ${currentFontPair[0] === item?.font ? 'is-hidden': ''}`} key={index}>
        {/* <span className="tooltip-msg" id={'tooltip-large-span' + index.toString()}>
          Click to select this font
        </span> */}
        <div className="font-name-search">
          <span className="font-name">{item?.font}</span>
          <button className="btn select-font" onClick={() => handleResetFont(index, item)}>
            <Tick /> <span>Select</span> <span className="hide-on-mobile">the font</span>
          </button>
        </div>
        <div onMouseMove={(e) => onmousemoveLarge(e,`tooltip-titlefont-${index}`)}>
            <span className="tooltip-msg" id={`tooltip-titlefont-${index}`}>
              Click to select this font
            </span>
            <TextareaAutosize
                value={HEADER_INPUT}
                style={{ fontFamily: `"${item.font}"`, fontSize: `${largeFontSize}px`, lineHeight: `${1.2*largeFontSize}px` }}
                spellCheck="false"
                onClick={() => handleResetFont(index, item)}
              />
        </div>      
        </div>
      </>
      )))
    };

    const ReactiveDescriptionList = ({data}) => {
      if(data.length <= 0) return
      return ( 
      data.map((item, index) => (
        <>
          { index === 0 &&
            <div className={`input-field-area`} key={-1}>
              <div className="font-name-search">
                <span className="font-name">{currentFontPair[1]}</span>
                <button className="btn select-font" onClick={() => handleResetFontSmall()}>
                  <Tick /> <span>Select</span> <span className="hide-on-mobile">the font</span>
                </button>
              </div>
              <TextareaAutosize
                  value={DESCRIPTION_INPUT}
                  style={{ fontFamily: `"${currentFontPair[1]}"`,fontSize: `${smallFontSize}px`, lineHeight: `${1.3*smallFontSize}px`, pointerEvents: 'none' }}
                  spellCheck="false"
                />
            </div>
          }
          <div className={`input-field-area ${currentFontPair[1] === item?.font ? 'is-hidden': ''}`} key={index}>
          {/* <span className="tooltip-msg" id={'tooltip-desc-span' + index.toString()}>
            Click to select this font
          </span> */}
          <div className="font-name-search">
            <span className="font-name">{item?.font}</span>
            <button className="btn select-font" onClick={() => handleResetFontSmall(index, item)}>
              <Tick /> <span>Select</span> <span className="hide-on-mobile">the font</span>
            </button>
          </div>
          <div onMouseMove={(e) => onmousemoveLarge(e,`tooltip-descfont-${index}`)}>
            <span className="tooltip-msg" id={`tooltip-descfont-${index}`}>
              Click to select this font
            </span>
            <TextareaAutosize
                value={DESCRIPTION_INPUT}
                style={{ fontFamily: `"${item.font}"`,fontSize: `${smallFontSize}px`, lineHeight: `${1.3*smallFontSize}px` }}
                spellCheck="false"
                onClick={() => handleResetFontSmall(index, item)}
              />
          </div>
          </div>
        </>
        )))
      };

  // const handleUpScroll = (element, activeClassElement) => {
  //   if(!activeClassElement.previousElementSibling) return
  //   if (activeClassElement.getBoundingClientRect().y - element.offsetHeight > 200) {
  //     activeClassElement.className = "input-field-area";
  //     activeClassElement.previousElementSibling.className = "input-field-area active"
  //   }

  // }
  
  // const handleDownScroll = (element, activeClassElement) => {
  //   if (activeClassElement.getBoundingClientRect().y > element.offsetHeight) {
  //     activeClassElement.className = "input-field-area";
  //     activeClassElement.previousElementSibling.nextElementSibling.className = "input-field-area active"
  //     return
  //   }
  //   activeClassElement.className = "input-field-area";
  //   activeClassElement.nextElementSibling.className = "input-field-area active"
  // }

  useEffect(() => {
    const f1 = searchParams.get('fontPair1')
    const f2 = searchParams.get('fontPair2')
    if (f1 === '' || f2 === '' || currentFontPair.length === 0|| currentFontPair[0] === '' || currentFontPair[1] === ''){
      if(!sessionStorage.getItem("check")) {
        sessionStorage.setItem("check", "yes");
      }
    }
    else if (f1 !== currentFontPair[0] || f2 !== currentFontPair[1]){
      setSearchParams(
        {
          fontPair1: currentFontPair[0],
          fontPair2: currentFontPair[1]
        }
      )
      setDoc({
        fontPair1: currentFontPair[0],
        fontPair2: currentFontPair[1]
      })
    }
  },[currentFontPair[0],currentFontPair[1]]);


  const onmousemoveLarge = (e, id)=> {
    const tooltipSpan = document.getElementById(id);
      var x = e.clientX,
      y = e.clientY;
      tooltipSpan.style.top = (y + 5) + 'px';
      tooltipSpan.style.left = (x + 5) + 'px';
  }
  const ReactiveHeader = () => {
    return <div className={`input-field-area active`} onMouseMove={(e) => onmousemoveLarge(e,'tooltip-large-span')}>
      <span className="tooltip-msg" id="tooltip-large-span">
        Click to edit text
      </span>
                {/* <span>{currentFontPair[0]}</span> */}
                <TextareaAutosize
                    inputMode ='text'
                    placeholder={"Click to add heading"}
                    className = "GA_textHeader"
                    style={{ fontFamily: `${"'"+currentFontPair[0]?.toString()+"'"}`,fontSize: `${largeFontSize}px`,lineHeight: `${1.2*largeFontSize}px`, border: "0px" }}
                    onChange={onChangeHeadingHandler}
                    value={headerInput}
                    onClick={ ()=>{
                      setisKeyboardOpen('L');
                    }}
                    onFocus={() => {
                      dispatch({ type: DISABLE_KEY_DOWN, payload: false });
                    }}
                    onBlur={() => {
                      dispatch({ type: DISABLE_KEY_DOWN, payload: true });
                    }}
                    spellCheck="false"
                  />
                  { isKeyboardOpen === 'L' &&
                    <div className="edit-text-help">
                      Tap the text to edit it
                    </div>
                  }
                  { isKeyboardOpen !== 'L' &&
                    <div className="mob_text_overlay"
                      onClick={() => {
                        setisKeyboardOpen('L');
                        setShowGetFontHeading(true);
                      }}></div>
                  }
                 </div>
  }

  const ReactiveDescription = () => {
    return <div className={`input-field-area active`}  onMouseMove={(e) => onmousemoveLarge(e,'tooltip-desc-span')}>
    <span className="tooltip-msg" id="tooltip-desc-span">
      Click to edit text
    </span>
      <TextareaAutosize
         placeholder={"Click to add body"}
         className = "GA_textBody"
         value={descriptionInput}
         style={{ fontFamily: `${"'"+currentFontPair[1]?.toString()+"'"}`,fontSize: `${smallFontSize}px`,lineHeight: `${1.3*smallFontSize}px`  }}
         onChange={onChangeDescriptionHandler}
         onFocus={() => {
          setisKeyboardOpen('S')
          dispatch({ type: DISABLE_KEY_DOWN, payload: false });
         }
        }
        onBlur={() => {
          dispatch({ type: DISABLE_KEY_DOWN, payload: true });
        }}
         spellCheck="false"
       />
       { isKeyboardOpen === 'S' &&
          <div className="edit-text-help">
            Tap the text to edit it
          </div>
        }
       { isKeyboardOpen !== 'S' &&
        <div className="mob_text_overlay"
          onClick={() => {
            setisKeyboardOpen('S');
            setShowGetFontBody(true);
          }}>
        </div>
      }
     </div>
  }

  useEffect(() => {
    if(props.help) setShowTutorial(true)
  },[props.help])
  

    return (
      <ReactiveBase 
          app="monotype_font"
          url={REACT_APP_ELASTIC_URL}
          credentials={REACT_APP_ELASTIC_CREDENTIALS}
          >
      <div
        className={`page-wrapper playground ${showTutorial ? "showTutorial" : ""} ${darkTheme ? "showDarkMode" : ""} ${scrolledWeb ? "scrolledView": ""} ${showSmallScrolledWeb ? "scrolledSmallView": ""}`}
        onClick={ToggleTutorialUI}
        ref={playgroundRef}>
        <Header setShowPairSec={setShowPairSec} showPairSec={showPairSec} setShowSidebar={setShowSidebar} showSidebar={showSidebar} likedPair={likedPair} help={props.help} showSmallScrolledWeb={showSmallScrolledWeb} scrolledWeb={scrolledWeb} setLoader={setLoader} canUndo={canUndo} canRedo={canRedo} undoDoc={undoDoc} redoDoc={redoDoc} isKeyboardOpen={isKeyboardOpen}/>
        <>
          <div
            className={
              showTutorial ? "fixed-tutorial" : "fixed-tutorial hideFixedTutor"
            }
          >
          </div>
          <Link
            className={`close-tutorial ${showTutorial ? "" : "hideFixedTutor"}`}
            to="/playground" onClick={() => handleCloseTutorial()}>
            <CloseIcon />
          </Link>
        </>
        <main className={`${showInstructions ? "instructions-footer-fixed": ""} ${showPairSec ? "main-content show-paired-sec align-items-start" : "main-content"}`}>
          {!showSidebar && 
            <div className={`left-fixed-font ${isKeyboardOpen !== '' ? "is-hidden": ""}`}>
              <button onClick={() => (!fontHeadingLock && !fontDescriptionLock) && dispatch({type: CHANGE_FONT, payload: [...currentFontPair].reverse() })}>
                <SwapIcon />
                <span>Swap fonts</span>
              </button>
            </div>
          }
          <div className="middle-playground-section">
            <div className="middle-playground-section__inner">
              <button className="close-scrolledView" onClick={() => {
                setScrolledWeb(false);
                setShowSmallScrolledWeb(false)
              }}>
                <ArrowBack />
                <span>back</span>
              </button>
              {
                !showSidebar && <div className="font-list-search largeFontSearch">
                <svg viewBox="0 0 16 16" fill="none">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.47619 2.28571C5.36481 2.28571 4.29894 2.72721 3.51308 3.51308C2.72721 4.29894 2.28571 5.36481 2.28571 6.47619C2.28571 7.02649 2.3941 7.5714 2.6047 8.07982C2.81529 8.58823 3.12395 9.05018 3.51308 9.43931C3.9022 9.82843 4.36415 10.1371 4.87257 10.3477C5.38098 10.5583 5.92589 10.6667 6.47619 10.6667C7.02649 10.6667 7.57141 10.5583 8.07982 10.3477C8.58823 10.1371 9.05018 9.82843 9.43931 9.43931C9.82843 9.05018 10.1371 8.58823 10.3477 8.07982C10.5583 7.57141 10.6667 7.02649 10.6667 6.47619C10.6667 5.36481 10.2252 4.29894 9.43931 3.51308C8.65344 2.72721 7.58757 2.28571 6.47619 2.28571ZM1.89683 1.89683C3.11135 0.682311 4.7586 0 6.47619 0C8.19378 0 9.84103 0.682311 11.0555 1.89683C12.2701 3.11135 12.9524 4.7586 12.9524 6.47619C12.9524 7.32666 12.7849 8.16879 12.4594 8.95452C12.281 9.38536 12.0569 9.79461 11.7918 10.1756L15.6653 14.049C16.1116 14.4953 16.1116 15.219 15.6653 15.6653C15.219 16.1116 14.4953 16.1116 14.049 15.6653L10.1756 11.7918C9.79461 12.0569 9.38536 12.281 8.95452 12.4594C8.16879 12.7849 7.32666 12.9524 6.47619 12.9524C5.62573 12.9524 4.78359 12.7849 3.99786 12.4594C3.21213 12.134 2.4982 11.6569 1.89683 11.0555C1.29546 10.4542 0.81843 9.74025 0.492971 8.95452C0.167512 8.16879 0 7.32666 0 6.47619C0 4.7586 0.682311 3.11135 1.89683 1.89683Z"
                  />
                </svg>
                <DataSearch
                  className="form-control"
                  componentId="searchbox"
                  dataField={["font", "font.autosuggest"]}
                  autosuggest={false}
                  queryFormat="or"
                  defaultValue=''
                  placeholder="Search fonts by name"
                  onFocus={() =>
                    dispatch({ type: DISABLE_KEY_DOWN, payload: false })
                  }
                  onKeyDown={() => dispatch({ type: DISABLE_KEY_DOWN, payload: false })}
                  showClear={true}
                />
                {/* <input type="text" className="form-control" placeholder="Search fonts by name" /> */}
              </div>}
              { (!isMobile || isKeyboardOpen === 'L' || isKeyboardOpen === '') &&
              <div id='largescroll' className="font-field-lists largeFont-list">
                { isFontLoading && !handleLockLargeFont ? 
                  <div className="playground-typetester__skeleton">
                    <div className="controls"></div>
                  </div>
                  :
                  <div className="get-font-main-section top-icons">
                    <div className="font-name">{currentFontPair[0]}</div>
                    <div className="hide-on-mobile">
                      <div className="get-font-icons">
                        <div className={fontHeadingLock ? "lock-icons locked-font GA_lockUnlockHeader" : 'lock-icons GA_lockUnlockHeader' }>
                          <button onClick={handleLockLargeFont}>
                            <OpenLock />
                            <span>Lock</span>
                          </button>
                          <button onClick={handleLockLargeFont}>
                            <CloseLock />
                            <span>Unlock</span>
                          </button>
                          <div className="tutorial-content-box">
                            <p>
                            To lock a font, click the lock icon.
                            </p>
                            <span className="dashed-linebar"></span>
                          </div>
                        </div>
                      </div>
                      <div title ={TOOLTIP.FONT_SIZE_SLIDER} className="middleArrow-circled GA_changeHeadingFont">
                        <div className="resize-wrapper">
                          <span>Resize</span>
                          <RCSlider
                            setLargeFontSize={setLargeFontSize}
                            type="large"
                            value={largeFontSize}
                            largeFontSize={largeFontSize}
                            setLargeFontSizeUpdated={setLargeFontSizeUpdated}
                            vertical/>
                        </div>
                      </div>
                      <div className="change-font">
                        <button onClick={onScroll}>
                            <ChangeFont />
                            Change font
                          </button>
                      </div>
                      <div title ={TOOLTIP.GET_FONT}  className="font-content-arrow GA_getHeaderFont">
                        <a href={reDirection_url_map.get(currentFontPair[0]) ? reDirection_url_map.get(currentFontPair[0])+CAMPAIGN_METADATA: `https://www.myfonts.com/search/${currentFontPair[0]}`+CAMPAIGN_METADATA} target={"_blank"} rel="noreferrer">
                          Get this font
                          <GetFont />
                        </a>
                      </div>
                    </div>
                    { showGetFontHeading &&
                      <div title ={TOOLTIP.GET_FONT}  className="font-content-arrow GA_getHeaderFont">
                        <a href={reDirection_url_map.get(currentFontPair[0]) ? reDirection_url_map.get(currentFontPair[0])+CAMPAIGN_METADATA: `https://www.myfonts.com/search/${currentFontPair[0]}`+CAMPAIGN_METADATA} target={"_blank"} rel="noreferrer">
                          Get this font
                          <GetFont />
                        </a>
                      </div>
                    }
                  </div>
                }
                { scrolledWeb ? <ReactiveList
                    showResultStats={false}
                    className="reactive-search"
                    componentId="results"
                    dataField="_doc"
                    size={100}
                    sortBy="desc"
                    scrollTarget={'largescroll'}
                    react={{ and: ["searchbox"] }}
                    //  style={{ textAlign: "center" }} 
                    
                    render={({data})=> <ReactiveHeaderList data={data}/>} /> 
                    : isFontLoading && !handleLockLargeFont ?
                      <div className="playground-typetester__skeleton">
                        <div className="heading"></div>
                        <div className="heading"></div>
                        <div className="heading"></div>
                      </div>
                    : ReactiveHeader()
                }
              </div>
              }
              { (!isMobile || isKeyboardOpen === 'S'|| isKeyboardOpen === '') &&
              <>
                <div className="playground-content">
                  <button className="close-scrolledSmallView" onClick={() => {
                    setShowSmallScrolledWeb(false)
                  }}>
                    <ArrowBack />
                    <span>back</span>
                  </button>
                  { isFontLoading && !fontDescriptionLock ? 
                  <div className="playground-typetester__skeleton">
                    <div className="controls"></div>
                  </div>
                  :
                    <div className="get-font-main-section">
                      <div className="font-name">{currentFontPair[1]}</div>
                      <div className="hide-on-mobile">
                        <div className="get-font-icons">
                          <div className={fontDescriptionLock ? "lock-icons locked-font GA_lockUnlockHeader" : 'lock-icons GA_lockUnlockHeader' }>
                            <button onClick={handleLockSmallFont}>
                              <OpenLock />
                              <span>Lock</span>
                            </button>
                            <button onClick={handleLockSmallFont}>
                              <CloseLock />
                              <span>Unlock</span>
                            </button>
                          </div>
                        </div>
                        <div title ={TOOLTIP.FONT_SIZE_SLIDER} className="middleArrow-circled 3 GA_changeBodyFont">
                        <div className="resize-wrapper">
                          <span>Resize</span>
                          <RCSlider
                            setSmallFontSize={setSmallFontSize}
                            type="small"
                            value={smallFontSize}
                            smallFontSize={smallFontSize}
                            setSmallFontSizeUpdated={setSmallFontSizeUpdated}
                            vertical/>
                          </div>
                        </div>
                        <div className="change-font">
                          <button onClick={onSmallScroll}>
                              <ChangeFont />
                              Change font
                            </button>
                        </div>
                        <div title ={TOOLTIP.GET_FONT} className="font-content-arrow GA_getBodyFont">
                          <a href={reDirection_url_map.get(currentFontPair[1]) ? reDirection_url_map.get(currentFontPair[1])+CAMPAIGN_METADATA: `https://www.myfonts.com/search/${currentFontPair[1]}`+CAMPAIGN_METADATA} target={"_blank"} rel="noreferrer">
                            Get this font
                            <GetFont />
                          </a>
                        </div>
                      </div>
                      { showGetFontBody &&
                        <div className="font-content-arrow GA_getBodyFont">
                          <a href={reDirection_url_map.get(currentFontPair[1]) ? reDirection_url_map.get(currentFontPair[1])+CAMPAIGN_METADATA: `https://www.myfonts.com/search/${currentFontPair[1]}`+CAMPAIGN_METADATA} target={"_blank"} rel="noreferrer">
                            Get this font
                            <GetFont />
                          </a>
                        </div>
                      }
                    </div>
                  }
                  {
                    !showSidebar && <div className="font-list-search">
                      <svg viewBox="0 0 16 16" fill="none">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6.47619 2.28571C5.36481 2.28571 4.29894 2.72721 3.51308 3.51308C2.72721 4.29894 2.28571 5.36481 2.28571 6.47619C2.28571 7.02649 2.3941 7.5714 2.6047 8.07982C2.81529 8.58823 3.12395 9.05018 3.51308 9.43931C3.9022 9.82843 4.36415 10.1371 4.87257 10.3477C5.38098 10.5583 5.92589 10.6667 6.47619 10.6667C7.02649 10.6667 7.57141 10.5583 8.07982 10.3477C8.58823 10.1371 9.05018 9.82843 9.43931 9.43931C9.82843 9.05018 10.1371 8.58823 10.3477 8.07982C10.5583 7.57141 10.6667 7.02649 10.6667 6.47619C10.6667 5.36481 10.2252 4.29894 9.43931 3.51308C8.65344 2.72721 7.58757 2.28571 6.47619 2.28571ZM1.89683 1.89683C3.11135 0.682311 4.7586 0 6.47619 0C8.19378 0 9.84103 0.682311 11.0555 1.89683C12.2701 3.11135 12.9524 4.7586 12.9524 6.47619C12.9524 7.32666 12.7849 8.16879 12.4594 8.95452C12.281 9.38536 12.0569 9.79461 11.7918 10.1756L15.6653 14.049C16.1116 14.4953 16.1116 15.219 15.6653 15.6653C15.219 16.1116 14.4953 16.1116 14.049 15.6653L10.1756 11.7918C9.79461 12.0569 9.38536 12.281 8.95452 12.4594C8.16879 12.7849 7.32666 12.9524 6.47619 12.9524C5.62573 12.9524 4.78359 12.7849 3.99786 12.4594C3.21213 12.134 2.4982 11.6569 1.89683 11.0555C1.29546 10.4542 0.81843 9.74025 0.492971 8.95452C0.167512 8.16879 0 7.32666 0 6.47619C0 4.7586 0.682311 3.11135 1.89683 1.89683Z"
                        />
                      </svg>
                    <DataSearch
                        className="form-control"
                        componentId="searchbox_description"
                        dataField={["font", "font.autosuggest"]}
                        placeholder="Search fonts by name"
                        autosuggest={false}
                        queryFormat="or"
                        defaultValue=''
                        onFocus={() =>
                          dispatch({ type: DISABLE_KEY_DOWN, payload: false })
                        }
                        onKeyDown={() => dispatch({ type: DISABLE_KEY_DOWN, payload: false })}
                        showClear={true}
                      />
                    </div>
                  }

                    <div id='smallscroll' className="font-field-lists font-field-lists-small">
                      { showSmallScrolledWeb ? <ReactiveList
                        className="reactive-search"
                        showResultStats={false}
                        componentId="results"
                        dataField="_doc"
                        size={100}
                        sortBy="desc"
                        scrollTarget={'smallscroll'}
                        react={{ and: ["searchbox_description"] }}
                        //  style={{ textAlign: "center" }} 
                        render={({data})=> <ReactiveDescriptionList data={data}/>} />
                        : isFontLoading && !fontDescriptionLock ?
                        <div className="playground-typetester__skeleton">
                          <div className="para"></div>
                          <div className="para"></div>
                          <div className="para"></div>
                          <div className="para"></div>
                          <div className="para"></div>
                          <div className="para"></div>
                        </div>
                        : ReactiveDescription()
                      }
                    </div>
                </div>
              </>
              }
            </div>
          </div>
          <div className={`pair-sec-wrapper ${showPairSec ? 'show-pairs': ''}`}>
            <button className="btn close-pairs" title="close pairs" aria-label="close pairs" onClick={closePairs}>
              <Cross />
            </button>
            <PairSection setShowPairSec={setShowPairSec} showPairSec={showPairSec} />
          </div>
          <div className="button-instructions-footer">
            <p className="content34">
              Press <span className="btn">spacebar</span> to randomise the pair,{" "}
              <span className="btn">L</span> to like, and{" "}
              <span className="btn">D</span> to dislike{" "}
            </p>
            <div className="tutorial-content-box">
              <p>Keyboard shortcuts</p>
              <span className="dashed-linebar"></span>
            </div>
          
            {/* <button title = {TOOLTIP.SHARE_PAIR}type="button" className="btn btn-share GA_share" onClick={shareButtonHandler}>
              <ShareIcon />
              Share the pair
            </button> */}
          
            {/* <button type="button" className="btn btn-share btn-mobile" onClick={shareButtonHandler}>
              <ShareIcon />
            </button> */}
          </div>
          {loader && <div className="loading-full-width">
          <svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" width={80} height={80} x="0px" y="0px"
              viewBox="0 0 100 100" enableBackground="new 0 0 0 0" >
                <path fill="#fff" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                  <animateTransform 
                    attributeName="transform" 
                    attributeType="XML" 
                    type="rotate"
                    dur="0.75s" 
                    from="0 50 50"
                    to="360 50 50" 
                    repeatCount="indefinite" />
              </path>
            </svg>
          </div>}
  
        </main>
        {
          shareUrlLink &&
          <div  className="share-modal" onClick={() => setShareUrlLink("")}>
            <div>
              <FacebookShareButton url={shareUrlLink} onClick={() => setShareUrlLink("")}>
                <FacebookIcon />
              </FacebookShareButton>
              <TwitterShareButton url={shareUrlLink} onClick={() => setShareUrlLink("")}>
                <TwitterIcon />
              </TwitterShareButton>
              <LinkedinShareButton url={shareUrlLink} onClick={() => setShareUrlLink("")}>
                <LinkedinIcon />
              </LinkedinShareButton>
              <EmailShareButton url={shareUrlLink} onClick={() => setShareUrlLink("")} openShareDialogOnClick>
                <EmailIcon />
              </EmailShareButton>
              <CopyToClipboard text={shareUrlLink} >
                <button className="copyClipboard-button" onClick={() => setShareUrlLink("")}>
                  <FileCopy />
                </button>
              </CopyToClipboard>
            </div>
          </div>
        }
        { isKeyboardOpen !== '' && showSmallScrolledWeb === false && scrolledWeb === false && 
            <div className="button_wrapper" ref={mobileTextActions}>
              <button className="button-act" onClick={handleChangeButton}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M4.84083 2C5.02012 2.00012 5.19585 2.06209 5.34833 2.17897C5.50081 2.29585 5.62402 2.46302 5.70416 2.66177L8.59254 9.82038C8.59927 9.83495 8.60571 9.84971 8.61185 9.86466L9.56789 12.2341C9.6825 12.5182 9.70136 12.847 9.62032 13.1483C9.53927 13.4496 9.36497 13.6986 9.13574 13.8407C8.90652 13.9827 8.64115 14.0061 8.39802 13.9056C8.15489 13.8052 7.95391 13.5892 7.8393 13.3052L7.14207 11.5735H2.54152L1.84236 13.3052C1.78813 13.4506 1.71086 13.5812 1.61515 13.6889C1.51944 13.7967 1.40723 13.8796 1.28519 13.9326C1.16314 13.9856 1.03375 14.0077 0.904679 13.9976C0.775609 13.9875 0.649496 13.9453 0.533821 13.8737C0.418146 13.802 0.315267 13.7023 0.231288 13.5804C0.14731 13.4585 0.0839426 13.317 0.0449463 13.1641C0.00595001 13.0113 -0.00788052 12.8504 0.00427511 12.6908C0.0164307 12.5313 0.0543252 12.3764 0.11571 12.2353L1.07174 9.86586L1.09009 9.82038L3.9775 2.66177C4.05765 2.46302 4.18086 2.29585 4.33334 2.17897C4.48582 2.06209 4.66154 2.00012 4.84083 2ZM3.50625 9.18015H6.17542L4.84083 5.8725L3.50625 9.18015Z" fill="#50565A"/>
                  <path d="M10.0151 2H10.5686L14.6508 12.8991C14.9102 13.5963 15.187 13.7798 16 13.8532V14H11.2951V13.8532C12.5405 13.7615 12.7308 13.6881 12.4886 12.9908L11.5134 10.6307H10.1831L9.72801 9.70642H11.3297L10.0151 5.94495L9.52851 4.53843L8.13755 7.07685L7.89209 6.26456L10.0151 2Z" fill="#50565A"/>
                </svg>
                  Change font
              </button>
              <div className="change-font-wrapper" ref={changeFontSize}>
                <button className="button-act change-font" onClick={handleChangeFontButton}>
                  <span>Resize</span>
                  <ChangeFontSize /> 
                </button>
                { isKeyboardOpen === 'L' && showFontSlider && 
                  <div className="change-font-slider">
                    <RCSlider
                      setLargeFontSize={setLargeFontSize}
                      type="large"
                      value={largeFontSize}
                      largeFontSize={largeFontSize}
                      setLargeFontSizeUpdated={setLargeFontSizeUpdated}
                      orientation="vertical"/>
                  </div>
                }
                { isKeyboardOpen === 'S' && showFontSlider && 
                  <div className="change-font-slider">
                    <RCSlider
                      setSmallFontSize={setSmallFontSize}
                      type="small"
                      value={smallFontSize}
                      smallFontSize={smallFontSize}
                      setSmallFontSizeUpdated={setSmallFontSizeUpdated}
                      orientation="vertical"/>
                  </div>
                }
              </div>
              { isKeyboardOpen === 'L' && 
                <div className="get-font-icons">
                  <div className={fontHeadingLock ? "lock-icons locked-font GA_lockUnlockHeader" : 'lock-icons GA_lockUnlockHeader' }>
                    <button onClick={handleLockLargeFont}>
                      <span>Lock</span>
                      <OpenLock />
                    </button>
                    <button onClick={handleLockLargeFont}>
                      <span>Unlock</span>
                      <CloseLock />
                    </button>
                  </div>
                </div>
              }
              { isKeyboardOpen === 'S' && 
                <div className="get-font-icons">
                  <div className={fontDescriptionLock ? "lock-icons locked-font GA_lockUnlockHeader" : 'lock-icons GA_lockUnlockHeader' }>
                    <button onClick={handleLockSmallFont}>
                      <OpenLock />
                    </button>
                    <button onClick={handleLockSmallFont}>
                      <CloseLock />
                    </button>
                  </div>
                </div>
              }
              <button className="button-act is-editing" onClick={handleDoneEditing}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M2 9.15385L5.75 13L14 3" stroke="#1A73E8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"s/>
                </svg>
              </button>
            </div>
        }
      </div>
      </ReactiveBase>
  
    );
  // }
  // return <PlaygroundLinkRender />
};

export default Playground;